// The call page's questions in scorecard order. The scorer stamps each result with its place on the
// scorecard (sortOrder 1..N), because the order of keys in Validations cannot be relied on: JSON
// readers put integer-like keys ("1", "2") first, whatever order they were written in.
//
// Results from before sortOrder existed keep the order they are listed in (the sort is stable), and
// sort after any that carry one.
const position = ({ parsed }) => {
  const value = Number(parsed?.sortOrder);
  return parsed?.sortOrder != null && Number.isFinite(value) ? value : Number.POSITIVE_INFINITY;
};

const orderValidationItems = (items) =>
  [...items].sort((a, b) => {
    const pa = position(a);
    const pb = position(b);
    return pa === pb ? 0 : pa - pb;
  });

export default orderValidationItems;
